<template>
    <div class="outerBox">
        <div class="innerBox" v-if="!mobile">
            <div class="row">
                <div class="col-12 mt-2 col-lg-7">
                    <h1 style="text-align: right;">Merk & Tipe Mobil</h1>
                </div>
                <div class="col-12 mt-2 pt-1 offset-lg-2 col-lg-3">
                    <button
                        class="btn btn-primary w-100"
                        @click="addCarBrandModel"
                    >
                        Tambah Merek dan Model Mobil
                    </button>
                </div>
            </div>
            
            <hr>
            <div class="row">
                <div class="col-3">
                    <search :mobile="mobile" @detail-of="detailOf"></search>
                </div>
                <div class="col-9" style="padding-left:30px">
                    <detail :mobile="mobile" :detailOf="idDetail" :isUpdate="isUpdate"></detail>
                </div>
            </div>
        </div>
        <div class="innerBox" v-else>
            <div class="pl-1 pr-1 mb-2">
            <button
                class="btn btn-primary w-100 "
                @click="addCarBrandModel"
            >
                Tambah Merek dan Model Mobil
            </button>
            </div>
            <search
                v-if="idDetail == null"
                :mobile="mobile"
                @detail-of="detailOf"
            ></search>
            <detail
                v-else
                :mobile="mobile"
                :detailOf="idDetail"
                :isUpdate="isUpdate"
                @backToSearch="idDetail = null"
            ></detail>
        </div>
    </div>
</template>

<script>
    import search from './childComponents/search'
    import detail from './childComponents/detail'

    export default{
        data(){
            return{
                idDetail : null,
                isUpdate : 0,
                mobile : this.isMobile(),
            }
        },
        components:{
            search,
            detail,
        },
        mounted(){

        },
        methods:{
            detailOf(id){
                this.idDetail = id;
                this.isUpdate++;
            },
            addCarBrandModel () {
                this.$router.push({name : 'CSOMasterAddBrandAndType'})
            }
        }
    }
</script>

<style>
    .content{
        height: 95vh;
        overflow: auto;
    }
</style>

<style scoped>
    .outerBox{
        padding: 20px !important;
    }
    .innerBox{
        border:1px solid #EEEEEE;
        border-radius:5px;
        background-color: white;
        padding:20px;
        /* box-shadow: 10px 10px 20px #E0E0E0; */
    }
</style>